
import { create } from 'zustand';

export interface UserAddress {
  id: string;
  calle: string;
  calleNro: number;
  deptoPiso?: string;
  codigoPostal: string;
  barrio: string;
  descLocalidad: string;
  descProvincia: string;
  descPais: string;
}

export interface UserClient {
  id: string;
  companyName: string;
  identityDocumentType: string;
  identityDocumentNumber: string;
}

interface UserState {
  selectedAddress: UserAddress | null;
  selectedClient: UserClient | null;
  addresses: UserAddress[];
  clients: UserClient[];
  
  // Actions
  setSelectedAddress: (address: UserAddress) => void;
  setSelectedClient: (client: UserClient) => void;
  setAddresses: (addresses: UserAddress[]) => void;
  setClients: (clients: UserClient[]) => void;
  clearUser: () => void;
}

export const useUser = create<UserState>((set) => ({
  selectedAddress: null,
  selectedClient: null,
  addresses: [],
  clients: [],

  setSelectedAddress: (address) => set({ selectedAddress: address }),
  setSelectedClient: (client) => set({ selectedClient: client }),
  setAddresses: (addresses) => set({ addresses }),
  setClients: (clients) => set({ clients }),
  clearUser: () => set({
    selectedAddress: null,
    selectedClient: null,
    addresses: [],
    clients: [],
  }),
}));

